import { qsStringify } from '@isyscore/utils/qs';
import { STANDARD_REQ_ORDER } from '../../order-define';
const jsonMIME = 'application/json';
export const reqStandard = () => {
    return {
        reqOrder: STANDARD_REQ_ORDER,
        reqInterceptor(req) {
            const { method = 'get', headers = {} } = req;
            const isGetMethod = method.toUpperCase() === 'GET';
            headers['accept'] = jsonMIME;
            req.paramsSerializer = (params) => qsStringify(params);
            req.headers = headers;
            req.method = method;
            if (isGetMethod)
                return req;
            const { data = {} } = req;
            const isFormData = data instanceof FormData;
            if (isFormData)
                return req;
            headers['content-type'] = jsonMIME;
            req.data = JSON.stringify(data);
            return req;
        }
    };
};
